import { useEffect, useState } from "react";
import { showErrorNotification, showSuccessNotification } from "../shared/Notifications";
import { useCreateFileRecordMutation, useGetUploadFilePresignedUrlMutation } from "../graphql/graphql";
import { getFileTypeFromMimeType } from "../utils/File.utils";
export const useFileUpload = ({ setFileName, setFileType, setContentType } = {}) => {
    const [files, setFiles] = useState([]);
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [, getPresignedUrl] = useGetUploadFilePresignedUrlMutation();
    const [, createFileUploadRecord] = useCreateFileRecordMutation();
    useEffect(() => {
        if (files.length > 0) {
            const firstFile = files[0];
            const mappedFileType = getFileTypeFromMimeType(firstFile.type);
            if (setFileType)
                setFileType(mappedFileType);
            const safeFileName = firstFile.name.replace(/[^a-zA-Z0-9]/g, "-");
            if (setFileName)
                setFileName(safeFileName);
            if (setContentType)
                setContentType(firstFile.type);
        }
    }, [files]);
    const uploadSingleFile = async ({ file, name, fileType, tags, isShared, caregiverId, patientId }) => {
        const { data } = await getPresignedUrl({
            input: {
                fileName: file.name,
                fileType: fileType,
                contentType: file.type
            }
        });
        const { presignedUrl } = data?.files?.createUploadFilePresignedUrl ?? {};
        if (!presignedUrl)
            throw new Error("No presigned URL found");
        const response = await fetch(presignedUrl, {
            method: "PUT",
            body: file,
            headers: { "Content-Type": file.type }
        });
        if (!response.ok)
            throw new Error(`File upload failed: ${response.statusText}`);
        const createResponse = await createFileUploadRecord({
            input: {
                name,
                fileName: file.name,
                fileType,
                contentType: file.type,
                tags,
                isShared,
                caregiverId,
                patientId
            }
        });
        if (createResponse?.error) {
            throw new Error(createResponse.error.message.replace("[GraphQL]", ""));
        }
        return response;
    };
    const uploadFiles = async (uploads) => {
        setIsUploadingFile(true);
        try {
            await Promise.all(uploads.map((u) => uploadSingleFile(u)));
            showSuccessNotification(`${uploads.length} file(s) uploaded successfully`);
        }
        catch (error) {
            const errorMessage = error instanceof Error
                ? error.message
                : "Failed to upload files";
            showErrorNotification(errorMessage);
            throw error;
        }
        finally {
            setIsUploadingFile(false);
        }
    };
    return {
        files,
        setFiles,
        uploadFiles,
        isUploadingFile
    };
};
